export default __webpack_public_path__ + "static/media/jh.9f6502db.png";